@if (roomStatusData(); as roomStatusData) {
	<div class="sh-online-rooms-status-cell">
		@if (!shouldDisplayStatusData) {
			<div class="sh-no-data-group-row"></div>
		} @else if (roomStatusData.errorType) {
			@if (roomStatusData.errorLevel) {
				<prism-icon-button
					[ngClass]="{
						'sh-room-warning-icon': roomStatusData.errorLevel === errorLevel.Warning,
						'sh-room-error-icon': roomStatusData.errorLevel === errorLevel.Error,
						'sh-device-rf-scan-in-progress-icon': roomStatusData.errorLevel === errorLevel.RFScanning
					}"
					[ngStyle]="{ '--prism-icon-button-color': roomStatusData.errorIcon?.colorToken }"
					[icon]="roomStatusData.errorIcon?.name"
					[label]="roomStatusData.message"
					tooltipPlacement="top"
					(click)="openRoomIncompatibleOrMissingDevicesDialog($event)"
				>
				</prism-icon-button>
			}

			@if (roomStatusData.hasUnauthenticatedDevices) {
				<prism-tooltip
					[text]="'shAgGrid.room-shell.tooltips.room-has-locked-devices' | transloco"
					placement="top"
				>
					<prism-icon class="sh-room-has-unauthenticated-device-icon" icon="sh-lock"></prism-icon>
				</prism-tooltip>
			}

			@if (roomStatusData.hasNewDevices) {
				<prism-icon-button
					class="sh-room-has-new-devices-icon"
					style="--prism-icon-button-color: var(--prism-color-theme-brand-orange)"
					icon="fiber_new"
					(click)="onNewDevicesButtonClick($event)"
					[label]="'shAgGrid.online-devices.new-device-setup.new' | transloco"
					placement="top"
				>
				</prism-icon-button>
			}
		} @else if (roomStatusData.isTrackingReOptimizeNeeded$ | async) {
			<prism-tooltip
				[text]="'shAgGrid.multi-array-localization.optimize-tracking.room-warning-status-message' | transloco"
				placement="top"
			>
				<prism-icon
					class="sh-room-warning-icon"
					style="color: var(--prism-color-theme-state-ok)"
					icon="sh-warning-outline"
				></prism-icon>
			</prism-tooltip>
		} @else if (isRowGroup) {
			<span class="sh-no-issues">
				{{ 'shAgGrid.online-devices.filter-options.device-status.no-issues' | transloco }}
			</span>
		}
	</div>
}
